import { render, staticRenderFns } from "./MatterProgramDescriptors.vue?vue&type=template&id=212bb119"
import script from "./MatterProgramDescriptors.vue?vue&type=script&setup=true&lang=js"
export * from "./MatterProgramDescriptors.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports